import { AnyAction } from "redux";

import * as types from "./types";

import { initialState } from ".";

export default function planningAndSchedulingReducer(
  state = initialState,
  action: AnyAction,
) {
  switch (action.type) {
    case types.OPEN_MODAL:
      return {
        ...state,
        isModalOpen: action.payload.isModalOpen,
      };
    case types.CLOSE_MODAL:
      return {
        ...state,
        isModalOpen: action.payload.isModalOpen,
        hasSubmissionError: false,
      };
    case types.OPEN_PLANNING_EVALUATION_TABLE_MODAL: {
      return {
        ...state,
        isPlanningEvaluationTableModalOpen:
          action.payload.isPlanningEvaluationTableModalOpen,
      };
    }
    case types.CLOSE_PLANNING_EVALUATION_TABLE_MODAL: {
      return {
        ...state,
        isPlanningEvaluationTableModalOpen:
          action.payload.isPlanningEvaluationTableModalOpen,
        isEvaluationDetailsShown: action.payload.isEvaluationDetailsShown,
      };
    }
    case types.SET_PLANNING_EVALUATION_DATA:
      return {
        ...state,
        planningEvaluationData: {
          ...state.planningEvaluationData,
          [action.payload.field]: action.payload.value,
        },
      };
    case types.CLEAR_PLANNING_EVALUATION_DATA:
      return {
        ...state,
        planningEvaluationData: initialState.planningEvaluationData,
      };
    case types.SUBMIT_PLANNING_EVALUATION: {
      return {
        ...state,
        isSubmitting: true,
        hasSubmissionError: false,
        planningEvaluationData: {
          ...action.payload.planningEvaluationData,
        },
      };
    }
    case types.SUBMIT_PLANNING_EVALUATION_SUCCESS: {
      return {
        ...state,
        isSubmitting: false,
        hasSubmissionError: false,
        submissionSuccess: true,
      };
    }
    case types.SUBMIT_PLANNING_EVALUATION_ERROR: {
      return {
        ...state,
        isSubmitting: false,
        submissionSuccess: false,
        hasSubmissionError: true,
      };
    }
    case types.RESET_PLANNING_EVALUATION_SUBMISISON: {
      return {
        ...state,
        submissionSuccess: action.payload.submissionSuccess,
      };
    }
    case types.FETCH_PLANNING_EVALUATION_STATUSES: {
      return {
        ...state,
        isFetchingStatuses: action.payload.isFetchingStatuses,
      };
    }
    case types.FETCH_PLANNING_EVALUATION_STATUSES_SUCCESS: {
      return {
        ...state,
        isFetchingStatuses: action.payload.isFetchingStatuses,
        statuses: [...action.payload.statuses],
      };
    }
    case types.FETCH_PLANNING_EVALUATION_STATUSES_ERROR: {
      return {
        ...state,
        isFetchingStatuses: action.payload.isFetchingStatuses,
        hasFetchingStatusesError: action.payload.hasFetchingStatusesError,
      };
    }
    case types.SHOW_PLANNING_EVALUATION_DETAILS: {
      return {
        ...state,
        isEvaluationDetailsShown: action.payload.isEvaluationDetailsShown,
        selectedEvaluation: action.payload.selectedEvaluation,
      };
    }
    case types.HIDE_PLANNING_EVALUATION_DETAILS: {
      return {
        ...state,
        isEvaluationDetailsShown: action.payload.isEvaluationDetailsShown,
        selectedEvaluation: null,
      };
    }
    default:
      return state;
  }
}
